// Initialize product card swipers efficiently
function initProductCardSwipers() {
  if (!window.Swiper) return;

  // Use a single mutation observer for all future product card swipers
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList?.contains('product-card-swiper')) {
          initSingleSwiper(node);
        }
      });
    });
  });

  // Initialize existing swipers
  document.querySelectorAll('.product-card-swiper:not(.swiper-initialized)').forEach(initSingleSwiper);

  // Watch for new product cards being added (e.g., infinite scroll, ajax loading)
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function initSingleSwiper(swiperEl) {
  if (swiperEl.classList.contains('swiper-initialized')) return;

  const nextEl = swiperEl.querySelector('.swiper-button-next');
  const prevEl = swiperEl.querySelector('.swiper-button-prev');

  new Swiper(swiperEl, {
    loop: false,
    navigation: {
      nextEl,
      prevEl,
      disabledClass: 'swiper-button-disabled',
    },
    slidesPerView: 1,
    spaceBetween: 0,
    on: {
      init: function() {
        if (prevEl) prevEl.style.display = 'none';
        if (nextEl) nextEl.style.display = this.isEnd ? 'none' : 'block';
      },
      slideChange: function() {
        if (prevEl) prevEl.style.display = this.isBeginning ? 'none' : 'block';
        if (nextEl) nextEl.style.display = this.isEnd ? 'none' : 'block';
      }
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCardSwipers);
} else {
  initProductCardSwipers();
}